import React from "react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import ModalToBody from "../../../base/ModalToBody";
import { ajaxErrorHandler, defaultSuccess } from "../../../libs/utils";
import moment from "moment";
import {
  daysBetweenDates,
  eventsToMaterialRequests,
  MaterialRequestForm
} from "../../forms/MaterialRequestFormNew";
import { createMaterialRequest } from "../../../services/api/materialRequests";
import { addDays } from "@fullcalendar/react";
import { addDaysRobust } from "../../forms/fields/FullCalendarNew";

class CreateMaterialRequestButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };

    this._closeModal = this._closeModal.bind(this);
    this._openModal = this._openModal.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
  }

  static propTypes = {
    registration: PropTypes.object,
    reloadRequests: PropTypes.func,
    admin: PropTypes.bool,
    materials: PropTypes.array,
    refreshRequests: PropTypes.func,
    event: PropTypes.object
  };

  _closeModal() {
    this.setState({ showModal: false });
    document.body.classList.remove("modal-open");
  }

  _openModal() {
    this.setState({ showModal: true });
    document.body.classList.add("modal-open");
  }

  _handleSubmit(values) {
    const self = this;

    return new Promise(async function(resolve, reject) {
      let dates = [];

      const quantityPerDay = [];

      const tc = eventsToMaterialRequests(values.requests, values.materialId);

      const materialRequestDays = values.requests.flatMap(period => {
        return Array.from({
          length: daysBetweenDates(period.start, period.end)
        }).map((_, i) => {
          const currentDay = addDaysRobust(period.start, i);
          return {
            quantity: period.amount ?? period.quantity,
            day: moment(currentDay).format("YYYY-MM-DD")
          };
        });
      });

      const registrationId = self.props.admin
        ? values.registrationId
        : self.props.registration.id;

      try {
        await createMaterialRequest(registrationId, {
          registrationId,
          forced: values.forced,
          quantityPerDay: materialRequestDays,
          materialId: values.materialId
        });
        self._closeModal();
        self.props.refreshRequests();
        defaultSuccess(
          "Your material-requests have been requested, we'll send you an email once this has been approved."
        );
        resolve();
      } catch (e) {
        ajaxErrorHandler(e);
        reject(e);
      }
    });
  }

  render() {
    const { showModal } = this.state;
    const { materials, registration, admin, event } = this.props;
    return (
      <div>
        <button
          type="button"
          className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
          onClick={this._openModal}
        >
          <span>
            <i className="la la-plus" />
            <span>
              <Trans>RegistrationMaterialRequestAddButton</Trans>
            </span>
          </span>
        </button>

        <ModalToBody>
          <div
            className="modal fade show"
            id="m_modal_4"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            style={{
              display: showModal ? "block" : "none",
              zIndex: "1039"
            }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    <Trans>Request Material</Trans>
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this._closeModal}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                {showModal && (
                  <MaterialRequestForm
                    registration={registration}
                    materials={materials}
                    onSubmit={this._handleSubmit}
                    admin={admin}
                    event={event}
                  />
                )}
              </div>
            </div>
          </div>

          <div
            className={"modal-backdrop fade " + (showModal ? " show" : "")}
            style={{
              display: showModal ? "block" : "none",
              zIndex: "1038"
            }}
          />
        </ModalToBody>
      </div>
    );
  }
}

export default props => {
  return <CreateMaterialRequestButton {...props} />;
};
